import { render, staticRenderFns } from "./NotificationBlockItem.vue?vue&type=template&id=084e8280&scoped=true&"
import script from "./NotificationBlockItem.vue?vue&type=script&lang=js&"
export * from "./NotificationBlockItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBlockItem.vue?vue&type=style&index=0&id=084e8280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e8280",
  null
  
)

export default component.exports